// extracted by mini-css-extract-plugin
export default {"link":"Article_link__t4i+c"};